import { render } from "./App.vue?vue&type=template&id=a6ef8afa&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=a6ef8afa&lang=scss"
import "./App.vue?vue&type=style&index=1&id=a6ef8afa&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__